import React from 'react';
import PersonTeaserBlock from 'components/person-teaser-block';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Authors = ({ items, className }) => {
  return items && items.length > 0 ? (
    <div className={cn('authors', className)}>
      <div className="authors__container">
        {items.map((item, index) => (
          <PersonTeaserBlock
            key={index}
            photo={item.photo}
            name={item.name}
            title={item.title}
            className="authors__item"
          />
        ))}
      </div>
    </div>
  ) : null;
};

Authors.viewModelMeta = {
  className: 'ignore',
};

Authors.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.exact(PersonTeaserBlock.propTypes)),
};

export default Authors;
